import { render } from "./BarbershopEntryView.vue?vue&type=template&id=05dea85c&scoped=true"
import script from "./BarbershopEntryView.vue?vue&type=script&lang=js"
export * from "./BarbershopEntryView.vue?vue&type=script&lang=js"

import "./BarbershopEntryView.vue?vue&type=style&index=0&id=05dea85c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05dea85c"]])

export default __exports__